import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import HandiesComponent from './handies.component';

let HandiesModule = angular
  .module('Handies', [
    uiRouter
  ])
  .component('handies', HandiesComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('handies', {
      url: '/handies',
      data: {
        authRequired: true,
        permsRequired: ['view-handies']
      },
      views: {
        'menu': 'menu',
        'content': {
          component: 'handies'
        }
      }
    });
  })
  .name;

export default HandiesModule;



// WEBPACK FOOTER //
// ./src/app/pages/handies/handies.module.js